webpackJsonp([106061173438730],{

/***/ 1606:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAMAAAAPzWOAAAABCFBMVEUAAAAjsNIksNMjsNMms9cjsNMjsNMjsdQlsdMlstUjsNMjsNMksNMlstcjsNMksNMmtNU6zvcjsNMjsNMjsNMlsdQjsNMksdQqttgjsNMjsNMksNMksNMksNMksdQjsNMksNMkr9MxtecjsNMlr9Ujr9L///76/f51zePt+PtoyOA0tdXG6vOc2+qe3Ovz+/3X8PZIvdknsNIlsNK55fCN1uhKvdpCutgwtNWs4e7i9PnZ8fe95/Gz5O+G0+YqstP8/v7B6fK25PCU2Oljxt9Vwdw8uNfw+fxdxN43ttYus9TT7/bN7fWm3+2C0eVQv9vc8veX2ep7z+Rvy+GK1Odkxt/k9fpUwNyXQ1D4AAAAJXRSTlMA+/KdJuC9gkY86eVzHO+JIQT2y69S02oXxLaqkXtZMqJfCpcwks3YtAAAA1xJREFUWMOtmOla4jAUhlP2RXZ03JeZ+U7BUVGxbLKIIOC+z9z/nUyTtnGqgi2Z90/TwvM2yTk9Tcqmk4otBFfCibyWDheK0c0Q8018PYF3JIOL330YfmbC+JR0JuVRESpiOtpa3IMiFdQwm+JXvclF8/iSwLeZjuUIPLESmhGSJDwSiE1zLGjwjLb5uSMKXyx82g/4JPPR8Q2+2XnvWIR/tPi7FEtjDhLutItgLgo59sYGJHOHKKRhTgLLUrKGuQnK8gEFtmzJKhSIMMEWlAgJyTqUiIo6lIASYS6JQRFeWrahyLYpSQLK40lBMLn9BcnkoAHg+PXgpGMcQfDrrnFvPF6arUap2Wl2zZZk2akBbTqVll2dhsCwRYKbEUwGVDbbXaBbIc5Zs/c2KU5RPCqbFuk4qaJ0RpVm12ibh4l5cZ/4aeO4w4+D/VOi6xFsNlgQbotwHGNyRucNmNSvqXzJJXodwCPRo+jCsEw3sCm+VZIatzgOHFKnCsHVA51zSZvfSScDHNEswWKFLcFlsR1D0uUUXZB+ZUpuzeYBtaqwMegBFkssjH8tLcuBAV2XJBXaNSUH4P274z9W9hrAiKhhx9iVJrUxUZs7cEIu7m1JhS6AuhUmjM0TQYIlwJFxoUMxjCa19iTtZ9iSMU2AS53oSRjtHMqzpMvRL1uWAfXhwpLc0Av/X9+oAhdyOGl7YmVsa5blns5kGowupMSglsyxDu3JibVCLHMMtqVPh1cQ1Mt05EiuxmaQBDwZh7BYZdtvjnPT4VhqFbquietleug5EpSI2jzpLgdEHVmsnbQfcofMXbMX92Oiw855i6hVh5TgjohO+ze6CKNN1HkA+8IhLbtAvamTiX4rpq9LL3bq7RHnd6kKh00WskcuL/KTJ3GX0fOdsWsnbu+1J+/xbDz96blKgXpRWmKMBaHIulyZKBbq7wEoERAL/h+Ko/l/r1EWUXyhC+JQIM7U1xZrzCE7d4DyWZWVsHz21JegK3wJqjigdJa5iGnwzyJ7x47CSlhhq7LBPiGjtN2RgfazfZu6I40nPMclxqaSKsAThRCbQW4j4CHXF3JsNstf1tzVLPuarQhmUIwzb2Sj4Sn1NBhiPogHP36E+RHLMb9kdzJrhXBayweShWJm1uegv1sYIOToIwVZAAAAAElFTkSuQmCC"

/***/ }),

/***/ 1607:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pos_xero.0604377e.png";

/***/ }),

/***/ 1608:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/small-business-integrations.b69787d5.jpg";

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Page = __webpack_require__(49);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _pageHeaderBanner = __webpack_require__(159);
	
	var _pageHeaderBanner2 = _interopRequireDefault(_pageHeaderBanner);
	
	var _section = __webpack_require__(23);
	
	var _section2 = _interopRequireDefault(_section);
	
	var _Footer = __webpack_require__(11);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _custom_a = __webpack_require__(83);
	
	var _custom_a2 = _interopRequireDefault(_custom_a);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _verticalTickBox = __webpack_require__(116);
	
	var _verticalTickBox2 = _interopRequireDefault(_verticalTickBox);
	
	var _columnInfoBox = __webpack_require__(91);
	
	var _columnInfoBox2 = _interopRequireDefault(_columnInfoBox);
	
	var _smallBusinessIntegrations = __webpack_require__(1608);
	
	var _smallBusinessIntegrations2 = _interopRequireDefault(_smallBusinessIntegrations);
	
	var _pos_xero = __webpack_require__(1607);
	
	var _pos_xero2 = _interopRequireDefault(_pos_xero);
	
	var _logo_xero = __webpack_require__(1606);
	
	var _logo_xero2 = _interopRequireDefault(_logo_xero);
	
	var _SEOInfo = __webpack_require__(19);
	
	var _SEOInfo2 = _interopRequireDefault(_SEOInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headerBannerProps = {
	  pageSubheader: "Xero + Yoco",
	  textColor: "black",
	  bgColor: "#f6f6f6",
	  pageText: _react2.default.createElement(
	    "p",
	    null,
	    "Automatic daily sales update and an up-to-date financial view of your business. ",
	    _react2.default.createElement("br", null),
	    " All seamless and in the cloud."
	  )
	};
	
	var tickBox = ["Xero is easy to use online accounting software that’s designed specifically for small businesses", "It's all online, so you can work when and where you want to. Just login with your PC, Mac or mobile", "Your bank statements are automatically imported and categorized, letting you see your cashflow in real time", "Invite your team and work together on financials. You can collaborate over your up to date numbers", "Xero has all you need to run your business – including invoicing, paying bills, sales tax returns, reporting and much more"];
	
	var costInfo = [{
	  heading: "Complete mobility",
	  paragraph: "Run your business from anywhere with Xero's cloud-based tracking and Yoco's mobile point of sale."
	}, {
	  heading: "Easy Recons",
	  paragraph: "All transactions from Yoco are fed and matched into Xero automatically. No more manual data entry - you won't know what to do with all your free time!"
	}, {
	  heading: "Real-time tracking",
	  paragraph: "All statements are at your fingertips and always up to date. Xero converts the Yoco daily summary into an invoice with sales, tips, fees and a tax breakdown."
	}];
	
	var IndexPage = function IndexPage(props) {
	  var location = props.location;
	
	  return _react2.default.createElement(
	    _Page2.default,
	    null,
	    _react2.default.createElement(_SEOInfo2.default, {
	      title: "Xero",
	      description: "",
	      canonicalLink: location.pathname
	    }),
	    _react2.default.createElement(_Header2.default, null),
	    _react2.default.createElement(_pageHeaderBanner2.default, _extends({ pageLogo: _logo_xero2.default }, headerBannerProps)),
	    _react2.default.createElement(
	      _section2.default,
	      { className: "pt-4 pb-0" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(_columnInfoBox2.default, {
	            data: costInfo,
	            headerStyle: { fontWeight: "bold" }
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-12 pt-4" },
	          _react2.default.createElement("img", { src: _smallBusinessIntegrations2.default, alt: "could not load image" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _section2.default,
	      { textAlign: "left" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-6" },
	            _react2.default.createElement(
	              "h2",
	              null,
	              "PARTNER FEATURES"
	            ),
	            _react2.default.createElement(
	              "h3",
	              { className: "pr-0" },
	              "What is Xero?"
	            ),
	            _react2.default.createElement(_verticalTickBox2.default, {
	              data: tickBox,
	              tickStyle: { marginTop: "35px", marginLeft: "7px" }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-6 plr-md-5" },
	            _react2.default.createElement(_Image2.default, { src: _pos_xero2.default })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _section2.default,
	      { bgColor: "#DEE6E9" },
	      _react2.default.createElement(_custom_a2.default, null)
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _headerBanner = __webpack_require__(32);
	
	var _headerBanner2 = _interopRequireDefault(_headerBanner);
	
	var _aphrodite = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageHeaderBanner = function (_HeaderBanner) {
	  _inherits(PageHeaderBanner, _HeaderBanner);
	
	  function PageHeaderBanner(props) {
	    _classCallCheck(this, PageHeaderBanner);
	
	    return _possibleConstructorReturn(this, _HeaderBanner.call(this, props));
	  }
	
	  PageHeaderBanner.prototype.render = function render() {
	    var _props = this.props,
	        pageLogo = _props.pageLogo,
	        pageSubheader = _props.pageSubheader,
	        pageText = _props.pageText;
	
	    return _react2.default.createElement(
	      "section",
	      {
	        style: {
	          backgroundColor: this.props.bgColor ? this.props.bgColor : "#BDB5B2",
	          color: this.props.textColor ? this.props.textColor : "white",
	          textAlign: "center"
	        }
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row " + (0, _aphrodite.css)(styles.bannerStyle) },
	          _react2.default.createElement(
	            "div",
	            { className: "col-12" },
	            _react2.default.createElement(
	              "div",
	              { className: "pt-md-5" },
	              _react2.default.createElement("img", {
	                src: pageLogo,
	                className: "pt-5 pb-4 text-right",
	                alt: "Image not yet available"
	              }),
	              _react2.default.createElement(
	                "h1",
	                { className: "pt-4 pb-4" },
	                pageSubheader
	              ),
	              pageText
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return PageHeaderBanner;
	}(_headerBanner2.default);
	
	exports.default = PageHeaderBanner;
	
	
	var styles = _aphrodite.StyleSheet.create({
	  bannerStyle: {
	    minHeight: "450px",
	    color: "#0c0c0c",
	    marginRight: "-25px!important",
	    marginLeft: "-25px!important"
	  },
	  fontStyle: {
	    fontWeight: "normal"
	  }
	});
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-za-integrations-xero-index-js-f504520be73118bbcada.js